export function getPublicApiUrl (env) {
  return env.VUE_APP_PUBLIC_API_URL || '/public-api'
}
